import React from 'react';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ConstructionBanner } from '@/components/ConstructionBanner';
import { Home } from '@/pages/Home';
import { MailClients } from '@/pages/MailClients';

export const App: React.FC = () => {
  const mailClients = window.location.pathname === '/mail-clients';
  return (
    <>
      <Header />
      {!mailClients && <ConstructionBanner />}
      {mailClients ? <MailClients /> : <Home />}
      <Footer />
    </>
  );
};
